import {
    defaultLevelFilterValue
} from '@containers/activity-router/routes/learn/challenges/components/challenges-ui-filters/level-filter/level-filter-constants';

export enum ChallengesAssignmentResultType {
    highestTeacherAssigned = 0,
    highestVoluntary,
    highest,
}

export const LevelFilter = {
    SELECT_ALL: defaultLevelFilterValue,
    MIN_LEVEL: 2,
    MAX_LEVEL: 11
};

export const CHALLENGES_STRAND = {
    NUMBER_ALGEBRA: 'number&algebra',
    STATISTICS_DATA: 'statistics&data',
    CHANCE_PROBABILITY: 'chance&probability',
    GEOMETRY: 'geometry',
    MEASUREMENT: 'measurement'
};

export const CHALLENGES_SUB_STRAND = {
    // Chance and Probability
    CHANCE_AND_PROBABILITY: 'chance&probability',

    // Geometry
    ANGLES: 'angle',
    GEOMETRIC_PROOF: 'geometricproof',
    SYMMETRY_TRANSFORMATION_AND_LOCATION: 'symmetrytransformation&location',
    THREE_DIMENSIONAL_SHAPE: '3dshape',
    TWO_DIMENSIONAL_SHAPE: '2dshape',

    // Measurement
    AREA: 'area',
    LENGTH: 'length',
    MASS: 'mass',
    PYTHAGORAS_AND_TRIGONOMETRY: 'pythagoras&trig',
    TIME: 'time',
    VOLUME_AND_CAPACITY: 'volume&capacity',
    TEMPERATURE: 'temperature',

    // Number and Algebra
    ADDITION_AND_SUBTRACTION: 'addition&subtraction',
    MULTIPLICATION_AND_DIVISION: 'multiplication&division',
    FRACTIONS: 'fractions',
    DECIMALS: 'decimals',
    INDICES: 'indices',
    MONEY: 'money',
    PATTERNS: 'patterns',
    EQUATIONS_AND_EXPRESSIONS: 'equations&expressions',
    NUMBER_THEORY: 'numbertheory',
    OPERATIONS: 'operations',
    PERCENTAGES: 'percentages',
    RATES_AND_RATIOS: 'rates&ratios',
    WHOLE_NUMBER: 'wholenumber',
    LOGARITHMS: 'logarithms',

    // Statistics and Data
    STATISTICS_AND_DATA: 'statistics&data'
};

export enum ChallengesPercentages {
	SCORE_0 = 0,
    SCORE_50 = 50,
    SCORE_80 = 80,
    SCORE_100 = 100
}

export const getChallengesGridCellDynamicStyle = (score: number) => {
    if(score >= ChallengesPercentages.SCORE_0 && score < ChallengesPercentages.SCORE_50) {
        return {
            background: 'linear-gradient(135deg, #FBDFE1 0%, #F1C4C7 100%)',
            color: 'error.900'
        };
    } else if(score >= ChallengesPercentages.SCORE_50 && score < ChallengesPercentages.SCORE_80) {
        return {
            background: 'linear-gradient(135deg, #FEE8AD 0%, #F3D88D 100%)',
            color: 'secondary.900'
        };
    } else if(score >= ChallengesPercentages.SCORE_80 && score <= ChallengesPercentages.SCORE_100) {
        return {
            background: 'linear-gradient(135deg, #8AEB8D 0%, #57CF5B 100%)',
            color: 'teal.900'
        };
    }

    return {
        background: '',
        color: ''
    };
};
